import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin instance
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/setup") && !path.startsWith("/agendar")) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// Client (public bookers) instance
export const clientApi = axios.create({ baseURL: API });
clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
clientApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/agendar") && path !== "/agendar/login" && path !== "/agendar/registrar") {
        localStorage.removeItem("client_token");
        localStorage.removeItem("client_user");
        const slug = localStorage.getItem("last_booking_slug");
        window.location.href = slug ? `/agendar/login?slug=${slug}` : "/agendar/login";
      }
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => { if (t) localStorage.setItem("token", t); else localStorage.removeItem("token"); };
export const getToken = () => localStorage.getItem("token");
export const setClientToken = (t) => { if (t) localStorage.setItem("client_token", t); else localStorage.removeItem("client_token"); };
export const getClientToken = () => localStorage.getItem("client_token");

// Normalizes FastAPI/Axios errors into a single human-readable string,
// so callers can safely pass the result to toast() / <Alert> without crashing React.
export const errMsg = (err, fallback = "Ocorreu um erro") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || x?.detail || JSON.stringify(x)).join(" · ");
  if (d && typeof d === "object") return d.msg || d.detail || JSON.stringify(d);
  return err?.message || fallback;
};
